import { forwardRef, useEffect, useState, useRef } from 'react';
// next
import { useRouter } from 'next/router';
// @mui
import { styled } from '@mui/material/styles';
import {
  Slide,
  Container,
  Dialog,
  IconButton,
  Stack,
} from '@mui/material';
// hooks
import useAuth from '../../hooks/useAuth';
// components
import Iconify from '../../components/Iconify';
// sections
import CandidateOfferForm from './CandidateOfferForm';
import PreMeetingCalendarForm from './PreMeetingCalendarForm';
// utils
import axios from '../../utils/axios';


const FormStyle = styled('div')(({ theme }) => ({
  maxWidth: 1200,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  marginBottom: theme.spacing(8),
}));

export default function JobPostOfferDialog({ isOpen, jobPost, candidateId, backToMatchingDialog, closeDialog, reload }) {
  const { user } = useAuth();
  const router = useRouter();
  const { query } = router;
  const [isLoading, setIsLoading] = useState(false);
  const [candidate, setCandidate] = useState(false);
  const [isPreMeetingCalendarForm, setIsPreMeetingCalendarForm] = useState(false);
  const dialogContentRef = useRef(null);

  const goNextForm = (v) => {
    if (v) {
      setIsPreMeetingCalendarForm(true);
      // 다이얼로그 스크롤을 최상단으로
      setTimeout(() => {
        if (dialogContentRef.current) {
          dialogContentRef.current.scrollTop = 0;
        }
      }, 100);
    } else {
      closeDialog();
    }
  }

  const reloadJobPostAndCandidate = () => {
    setIsPreMeetingCalendarForm(false);
    reload(jobPost?.id);
    loadData();
  }

  useEffect(() => {
    if (isOpen && query?.wt) {
      if (query.wt === 'y') {
        setIsPreMeetingCalendarForm(true);
        // 쿼리파라미터로 열릴 때도 스크롤 최상단으로
        setTimeout(() => {
          if (dialogContentRef.current) {
            dialogContentRef.current.scrollTop = 0;
          }
        }, 100);
      }
    }
  }, [isOpen, query])

  useEffect(() => {
    if (!isOpen) {
      setIsPreMeetingCalendarForm(false);
      setCandidate('');
    } else if (isOpen && !candidate && candidateId) {
      loadData();
    } else if (isOpen && candidate) {
      const shouldShowTimeForm = candidate?.status === "reselect-3way-time";
      setIsPreMeetingCalendarForm(shouldShowTimeForm);
      if (shouldShowTimeForm) {
        // status로 인해 PreMeetingCalendarForm이 표시될 때도 스크롤 최상단으로
        setTimeout(() => {
          if (dialogContentRef.current) {
            dialogContentRef.current.scrollTop = 0;
          }
        }, 100);
      }
    }
  }, [isOpen, candidate])

  const loadData = async () => {
    try {
      if (jobPost?.id) {
        setIsLoading(true);
        const companyId = user?.employee.company[0].id;
        const jobPostId = jobPost.id;
        const candidateResponse = await axios.get(`/api/company/${companyId}/job-posts/${jobPostId}/candidate/${candidateId}/`);
        setCandidate(candidateResponse?.data);
        setIsLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Dialog fullScreen open={isOpen} onClose={closeDialog} transitionDuration={0} PaperProps={{ ref: dialogContentRef }}>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
        <IconButton color="inherit" onClick={() => backToMatchingDialog()} sx={{ ml: 2, mt: 2 }}>
          <Iconify icon="ic:chevron-left" sx={{ width: 32 , height: 32, color: (theme) => theme.palette.text.primary }} />
        </IconButton>
        <IconButton color="inherit" onClick={closeDialog} sx={{ mr: 2, mt: 2 }}>
          <Iconify icon="eva:close-fill" sx={{ width: 32 , height: 32, color: (theme) => theme.palette.text.primary }} />
        </IconButton>
      </Stack>

      <Container>
        <FormStyle>
        {!isPreMeetingCalendarForm && (
          <CandidateOfferForm
            jobPost={jobPost}
            isLoading={isLoading}
            candidate={candidate}
            loadData={loadData}
            next={(v) => goNextForm(v)}
            closeDialog={closeDialog}
            backToMatchingDialog={backToMatchingDialog}
            reloadAll={reloadJobPostAndCandidate}
          />
        )}
        {isPreMeetingCalendarForm && (
          <PreMeetingCalendarForm jobPost={jobPost} candidate={candidate} reload={reloadJobPostAndCandidate} />
        )}
        </FormStyle>
      </Container>
    </Dialog>
  )
}
